import './deliverySummary.scss';
import cn from 'classnames';
import {
	NOTIFICATION_STATUS,
	RECIPIENT_STATUS_GROUPS,
	formatPercentage,
	getDispatchProgress,
	groupRecipientStats,
} from 'helpers/notificationDelivery';

export const DeliverySummary = ({ notification, isPolling }) => {
	const stats = notification?.stats;
	if (!stats?.total) return null;

	const isProcessing = notification.status === NOTIFICATION_STATUS.PROCESSING;
	const progress = getDispatchProgress(stats);
	const dispatched = stats.total - stats.pending - stats.processing;

	// Canceled only shows up when there is something to show
	const groups = groupRecipientStats(stats).filter(
		({ key, count }) => key !== RECIPIENT_STATUS_GROUPS.CANCELED || count > 0,
	);

	return (
		<div className="DeliverySummary">
			{isProcessing && (
				<div className="DeliverySummary__progress">
					<div className="DeliverySummary__progress__header">
						<span>Handing messages to Twilio</span>
						<span>
							{dispatched.toLocaleString()} of {stats.total.toLocaleString()} (
							{Math.floor(progress)}%)
						</span>
					</div>
					<div
						className="DeliverySummary__progress__track"
						role="progressbar"
						aria-valuemin={0}
						aria-valuemax={100}
						aria-valuenow={Math.floor(progress)}>
						<div
							className="DeliverySummary__progress__bar"
							style={{ width: `${progress}%` }}
						/>
					</div>
					{isPolling && (
						<span className="DeliverySummary__hint">
							This page updates automatically.
						</span>
					)}
				</div>
			)}
			<div className="DeliverySummary__stats">
				{groups.map(({ key, label, count }) => (
					<div
						key={key}
						className={cn(
							'DeliverySummary__stat',
							`DeliverySummary__stat--${key}`,
						)}>
						<span className="DeliverySummary__stat__label">{label}</span>
						<span className="DeliverySummary__stat__value">
							{count.toLocaleString()}
						</span>
						<span className="DeliverySummary__stat__percentage">
							{formatPercentage(count, stats.total)}
						</span>
					</div>
				))}
			</div>
		</div>
	);
};
